/** Parses an API timestamp, treating an unusable value as absent. */
export const toEpochMs = (iso: string | null | undefined) => {
  if (!iso) {
    return undefined;
  }
  const parsed = new Date(iso).getTime();
  return Number.isFinite(parsed) ? parsed : undefined;
};
